<!-- 年补贴数量前五名机具 -->
<template>
  <div class="rank">
    <div class="fourth common-flex">
      <p class="common-p" v-show="turnNeed(machinerySubsidyRank[3]).mcc != '--'">{{turnNeed(machinerySubsidyRank[3]).mcc}}</p>
      <div class="common-div" v-show="turnNeed(machinerySubsidyRank[3]).numMachines != 0">{{turnNeed(machinerySubsidyRank[3]).numMachines | toThousandFilter}}台</div>
    </div>
    <div class="second common-flex">
      <p class="common-p" v-show="turnNeed(machinerySubsidyRank[1]).mcc != '--'">{{turnNeed(machinerySubsidyRank[1]).mcc}}</p>
      <div class="common-div" v-show="turnNeed(machinerySubsidyRank[1]).numMachines != 0">{{turnNeed(machinerySubsidyRank[1]).numMachines | toThousandFilter}}台</div>
    </div>
    <div class="first common-flex">
      <p class="common-p"  v-show="turnNeed(machinerySubsidyRank[0]).mcc != '--'">{{turnNeed(machinerySubsidyRank[0]).mcc}}</p>
      <div class="common-div" v-show="turnNeed(machinerySubsidyRank[0]).numMachines != 0">{{turnNeed(machinerySubsidyRank[0]).numMachines | toThousandFilter}}台</div>
    </div>
    <div class="third common-flex">
      <p class="common-p"  v-show="turnNeed(machinerySubsidyRank[2]).mcc != '--'">{{turnNeed(machinerySubsidyRank[2]).mcc}}</p>
      <div class="common-div" v-show="turnNeed(machinerySubsidyRank[2]).numMachines != 0">{{turnNeed(machinerySubsidyRank[2]).numMachines | toThousandFilter}}台</div>
    </div>
    <div class="fifth common-flex">
      <p class="common-p"  v-show="turnNeed(machinerySubsidyRank[4]).mcc != '--'">{{turnNeed(machinerySubsidyRank[4]).mcc}}</p>
      <div class="common-div" v-show="turnNeed(machinerySubsidyRank[4]).numMachines != 0">{{turnNeed(machinerySubsidyRank[4]).numMachines | toThousandFilter}}台</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'subsidyRank',
  props: {
    machinerySubsidyRank: {
      type: Array,
      default: [],
    }
  },
  computed: {
    turnNeed() {
      return function(obj){
        let result = {
          mcc: '--',
          numMachines: 0,
        }
        if(obj) {
          result.mcc = obj.mcc || '--';
          result.numMachines = obj.numMachines || 0;
          if(result.mcc.length > 10) {
            result.mcc = result.mcc.slice(0, 9) + '...'
          }
          return result
        }else {
          return result;
        }
      }
    }
  },
  data() {
    return {
 
    }
  },
  methods: {
 
  },
  mounted() {
     
  }
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.rank {
  height: 100%;
  display: flex;
  align-items: flex-end;
  font-size: fontSize(14);
  div {
    width: vw(88);
    background-repeat: no-repeat;
  }
  .fourth {
    background-image: url("../../../../assets/images/governmentAffairs/purchaseAllowance/pic_ranking_fourth.png");
    background-size: 100%;
    height: vh(143);
  }
  .second {
    background-image: url("../../../../assets/images/governmentAffairs/purchaseAllowance/pic_ranking_second.png");
    background-size: 100%;
    height: vh(175);
  }
  .first {
    background-image: url("../../../../assets/images/governmentAffairs/purchaseAllowance/pic_ranking_first.png");
    background-size: 100%;
    height: vh(191);
  }
  .third {
    background-image: url("../../../../assets/images/governmentAffairs/purchaseAllowance/pic_ranking_third.png");
    background-size: 100%;
    height: vh(159);
  }
  .fifth {
    background-image: url("../../../../assets/images/governmentAffairs/purchaseAllowance/pic_ranking_fifth.png");
    background-size: 100%;
    height: vh(127);
  }
  .common-p {
    color: #E8F5FF;
    padding: 0 vw(8);
    margin-top: vh(60);
    margin-bottom: vh(6);
    text-align: center;
    line-height: vh(17);
  }
  .common-div {
    width: vw(74);
    height: vh(20);
    background: #003213;
    border-radius: 10px;
    color: #5FFF97;
    text-align: center;
  }
  .common-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
